import { defineComponent as l, openBlock as n, createElementBlock as c, createVNode as t, unref as o, withCtx as a, createElementVNode as i, createBlock as m, resolveDynamicComponent as p, normalizeClass as u, createTextVNode as _, toDisplayString as b, createCommentVNode as f } from "vue";
import C from "./ghl-ui.es620.js";
import "./ghl-ui.es22.js";
import "./ghl-ui.es621.js";
import w from "./ghl-ui.es204.js";
import k from "./ghl-ui.es62.js";
import x from "./ghl-ui.es345.js";
const B = {
  key: 0,
  class: "dropdown-tree__breadcrumb"
}, h = { class: "dropdown-tree__breadcrumb-content" }, v = { class: "dropdown-tree__breadcrumb-title" }, N = l({
  __name: "BreadCrumb",
  props: {
    disabled: Boolean,
    title: String,
    show: Boolean,
    icon: Function,
    iconClass: String
  },
  emits: ["onClick"],
  setup(e, { emit: s }) {
    const d = s;
    return (y, r) => e.show ? (n(), c("div", B, [
      t(o(k), {
        id: "dropdown-backward-traversal",
        text: "",
        onClick: r[0] || (r[0] = (V) => d("onClick")),
        disabled: e.disabled
      }, {
        default: a(() => [
          i("div", h, [
            t(o(C), { class: "w-5 h-5" }),
            i("span", v, [
              (n(), m(p(e.icon), {
                class: u(e.iconClass)
              }, null, 8, ["class"])),
              t(o(x), {
                style: { "max-width": "250px" },
                tooltip: !1
              }, {
                default: a(() => [
                  _(b(e.title), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["disabled"])
    ])) : f("", !0);
  }
}), T = /* @__PURE__ */ w(N, [["__scopeId", "data-v-565aecec"]]);
export {
  T as default
};
